export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_9-10c33af68263c20c7b24365efb2b5f7d.jpg";